/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */

var windowScrollTop;
var windowWidth;
var articleUnderlineTop;

if ($('#article-underline').length){
	var articleUnderline = $('#article-underline');
}

function fn_parts_scroll_resize(){
	windowScrollTop = $(window).scrollTop();
	windowWidth = $(window).width();
	windowHeight = $(window).height();

	if ($('#article-underline').length){
		articleUnderlineTop = articleUnderline.offset().top;
		if (windowScrollTop > articleUnderlineTop  - ( windowHeight / 1.1)) {
			articleUnderline.addClass( class_active );
		}
	}
}
